import { ACTIONS_COLLAPSE_WIDTH } from 'conversations-inbox-message-history/common-message/CommonMessage';
import { getUniqueRecipientsCount } from 'conversations-inbox-message-history/common-message/operators/getUniqueRecipientsCount';
import { getGenericChannelId } from 'conversations-message-history/common-message-format/operators/commonMessageGetters';
import { getConnectedAccountAddress, getFromAddress } from 'conversations-message-history/common-message-format/operators/emailMetadataGetters';
import { isForwardableEmailOrFormCMF
// @ts-expect-error module not typed
} from 'conversations-message-history/common-message-format/operators/cmfComparators';
// @ts-expect-error module not typed
import { getMessageId } from 'conversations-message-history/message-history/operators/getMessageId';
import { getScopesAsMap, getUserId } from 'conversations-thread-data/auth/public/selectors';
import { useSelector } from 'react-redux';
import { CONVERSATIONS_ADMIN, CONVERSATIONS_MESSAGE_HIDING } from 'conversations-internal-schema/constants/Scopes';
import FormattedMessage from 'I18n/components/FormattedMessage';
import HiddenMessage from 'conversations-inbox-message-history/common-message/HiddenMessage';
import { useMessageHiding } from '../../message-actions/hooks/useMessageHiding';
import MessageActionsStandard from 'conversations-inbox-message-history/common-message-actions/MessageActionsStandard';
import { useContainerQuery } from 'conversations-inbox-message-history/util/useContainerQuery';
import { jsx as _jsx } from "react/jsx-runtime";
export default function withMessageActions(Comp) {
  const WrappedComponent = props => {
    const {
      message,
      onClickToReplyAll,
      onClickToReply,
      onClickToForward,
      slots
    } = props;
    const hiddenBy = message.hiddenBy;
    const hiddenMessageActor = hiddenBy === null || hiddenBy === void 0 ? void 0 : hiddenBy.get('actorId');
    const scopes = useSelector(getScopesAsMap);
    const userId = useSelector(getUserId);
    const hasAdminScope = scopes.has(CONVERSATIONS_ADMIN);
    const hasMessageHidingScope = scopes.has(CONVERSATIONS_MESSAGE_HIDING);
    const messageUnhidingPermissionEnabled = hasAdminScope || (hiddenMessageActor === null || hiddenMessageActor === void 0 ? void 0 : hiddenMessageActor.includes(`-${userId}`));
    const fromAddress = getFromAddress(message);
    const connectedAccountAddress = getConnectedAccountAddress(message);
    const isFromSelf = connectedAccountAddress === fromAddress;
    const multipleRecipientThreshold = isFromSelf ? 1 : 0;
    const canShowComm = isForwardableEmailOrFormCMF(message);
    const uniqueRecipientsCount = getUniqueRecipientsCount({
      message
    });
    const hasMultipleRecipients = uniqueRecipientsCount > multipleRecipientThreshold;
    const genericChannelId = getGenericChannelId(message);
    const messageId = getMessageId(message);
    const hiddenMessageComponent = /*#__PURE__*/_jsx(HiddenMessage, {
      tooltip: messageUnhidingPermissionEnabled ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-message-history.common-message.hiddenMessage.tooltip"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-message-history.common-message.hiddenMessage.tooltipWithoutPermission"
      })
    });
    const {
      handleUnhideMessage,
      handleHideMessage
    } = useMessageHiding();
    const [breakpointResults, messageContainerRef] = useContainerQuery([ACTIONS_COLLAPSE_WIDTH]);
    const actionsCollapsed = breakpointResults[ACTIONS_COLLAPSE_WIDTH];
    const MessageActionsComponent = (slots === null || slots === void 0 ? void 0 : slots.messageActions) || MessageActionsStandard;
    return /*#__PURE__*/_jsx(Comp, Object.assign({}, props, {
      messageContainerRef: messageContainerRef,
      messageActions: /*#__PURE__*/_jsx(MessageActionsComponent, {
        allowCommunicatorButtons: canShowComm,
        allowHiddenMessages: true,
        allowUnhidingMessage: !!messageUnhidingPermissionEnabled,
        allowReplies: true,
        messageHidingEnabled: hasMessageHidingScope,
        genericChannelId: genericChannelId,
        hiddenBy: hiddenBy,
        hasMultipleRecipients: hasMultipleRecipients,
        messageId: messageId,
        onClickToHideMessage: () => handleHideMessage(messageId, userId),
        onClickToShowMessage: () => handleUnhideMessage(messageId, userId),
        onClickToReplyAll: onClickToReplyAll,
        onClickToReply: onClickToReply,
        onClickToForward: onClickToForward,
        shouldCollapseActions: actionsCollapsed
      }),
      hiddenMessage: hiddenMessageComponent
    }));
  };
  WrappedComponent.displayName = `withMessageActions(${Comp.displayName})`;
  return WrappedComponent;
}